<script setup>
const key='uogorod.banner-app-closed';
const cookie=useCookie(key,{path:'/',sameSite:'lax',maxAge:34560000,default:()=>false});
const isClosed=value=>value===true||String(value)==='true';
// Catalog HTML is shared by SWR: keep its initial markup independent of cookies.
const closed=useState('help-banner-dismissed',()=>false);
// Apply the visitor's preference before paint, including older local-only dismissals.
useHead({script:[{key:'help-banner-preference',innerHTML:`(()=>{let closed=document.cookie.split(';').some(v=>v.trim()==='${key}=true');try{closed=closed||localStorage.getItem('${key}')==='true'}catch{}if(closed)document.documentElement.dataset.helpBannerDismissed='true'})()`} ]});
function close(){closed.value=true;cookie.value=true;if(import.meta.client)document.documentElement.dataset.helpBannerDismissed='true';try{localStorage.setItem(key,'true');}catch{}}
const sync=event=>{if(event.key===key && event.newValue==='true')close();};
onMounted(()=>{
 let stored=false;try{stored=localStorage.getItem(key)==='true';}catch{}
 closed.value=isClosed(cookie.value) || stored;
 if(closed.value)close();
 window.addEventListener('storage',sync);
});
onBeforeUnmount(()=>window.removeEventListener('storage',sync));
</script>
<template>
 <aside v-if="!closed" class="uo-help-banner md:rounded-lg bg-indigo-600 p-2 shadow-lg sm:p-3" aria-label="Вопросы по сайту">
  <div class="flex flex-wrap items-center justify-between gap-2">
   <p class="font-medium text-white m-0 flex-1">Любые вопросы по Умному Огороду</p>
   <NuxtLink class="flex items-center justify-center rounded-md bg-white px-4 py-2 text-sm font-medium text-indigo-600" to="/feed/1243">Задать вопрос</NuxtLink>
   <button @click="close" type="button" aria-label="Закрыть баннер вопросов" class="text-white flex rounded-md p-2 hover:bg-indigo-500 focus-visible:outline min-h-11">Закрыть</button>
  </div>
 </aside>
</template>
<style scoped>
:global(html[data-help-banner-dismissed="true"] .uo-help-banner){display:none}
</style>
